import { log, supabase } from ".";

export const deleteIntermediario = async (id) => {
  try {
    const data = await supabase.remove("intermediarios", id);

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    log.error("deleteIntermediario", error);
    throw error;
  }
};
